<template>
  <NtAuthTemplate>
    <v-row dense align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card color="loginBackground">
          <v-card-text class="text-center">
            <img class="my-3" :src="info.app_logo"/>
            <h3 class="text-h5 mt-4 mb-0">Redefinir senha</h3>
            <v-row dense>
              <v-col cols="12">
                <v-alert v-if="notifica.show" :color="notifica.color" :icon="notifica.icon" value="true">
                  {{ notifica.mensagem }}
                </v-alert>
                <v-form @submit.prevent="requestRedefinirSenha()" method="post" id="reset" v-if="formEmailActive">
                  <v-text-field
                    name="email"
                    label="Email"
                    hint="Digite seu email"
                    v-model="formEmail.email"
                    required
                    prepend-icon="mdi-account"
                    type="text"
                    :error="error.error"
                    :error-messages="error.messages"
                    autocomplete="off"
                    autofocus
                    color="loginFont"/>
                </v-form>
                <v-form @submit.prevent="redefinirSenha()" method="post" id="redefine" v-else-if="formResetPasswordActive">
                  <div v-show="userNotEmpty">
                    <span>Olá <b>{{user.name}}</b>, defina uma nova senha.</span>
                  </div>
                  <v-text-field
                    name="password"
                    label="Senha"
                    v-model="formResetPassword.password"
                    required
                    prepend-icon="mdi-key"
                    :append-icon="passVisibility ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="passVisibility = !passVisibility"
                    :type="passVisibility ? 'text' : 'password'"
                    autofocus
                    color="loginFont"/>
                  <v-text-field
                    name="password_confirmation"
                    label="Confirmação de Senha"
                    v-model="formResetPassword.password_confirmation"
                    required
                    prepend-icon="mdi-key"
                    :append-icon="passVisibility ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="passVisibility = !passVisibility"
                    :type="passVisibility ? 'text' : 'password'"
                    :error="error.error"
                    :error-messages="error.messages"
                    color="loginFont"/>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text exact :to="{ name: 'auth.login' }">Cancelar</v-btn>
            <v-spacer/>
            <v-btn exact type="submit" form="reset" v-if="formEmailActive" color="loginButton">Solicitar nova senha</v-btn>
            <v-btn exact type="submit" form="redefine" v-else-if="formResetPasswordActive" color="loginButton">Redefinir</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </NtAuthTemplate>
</template>

<script>
import { ResetPassword } from '@/services/resources'
import NtAuthTemplate from '@/components/Utils/NtAuthTemplate'
import { mapGetters } from 'vuex'

export default {
  components: {
    NtAuthTemplate
  },
  mounted () {
    if (this.isAuth) {
      this.$router.push({ name: 'ambienteAluno.dashboard' })
    }

    if (this.$route.params.token) {
      this.user = {}
      this.formEmailActive = false
      this.formResetPasswordActive = true
      this.formResetPassword.token = this.$route.params.token
      this.getUserByToken()
    }
  },
  data () {
    return {
      formEmailActive: true,
      formResetPasswordActive: false,
      formEmail: {
        email: ''
      },
      formResetPassword: {
        password: '',
        password_confirmation: '',
        token: ''
      },
      error: {
        error: false,
        messages: []
      },
      user: {},
      notifica: {
        show: false,
        color: '',
        icon: '',
        mensagem: ''
      },
      passVisibility: false
    }
  },
  methods: {
    requestRedefinirSenha () {
      this.notifica.show = false
      this.error.error = false
      this.error.messages = []
      ResetPassword.request(this.formEmail)
        .then(response => {
          this.formEmail.email = ''
          this.notifica = {
            show: true,
            color: 'info',
            icon: 'check_circle',
            mensagem: 'Um email de recuperação de senha foi enviado. Confira sua caixa de entrada e siga as instruções do email.'
          }
        })
        .catch(responseError => {
          this.error.error = true
          if (responseError.status === 404) {
            this.error.messages.push('Nenhum usuário encontrado com este email')
          } else {
            this.error.messages.push(responseError.statusText)
          }
        })
    },
    getUserByToken () {
      this.notifica.show = false
      ResetPassword.getUserByToken(this.formResetPassword.token)
        .then(response => {
          console.log(response.data)
          this.user = response.data.user
          console.log(this.user)
        })
        .catch(responseError => {
          if (responseError.status === 412) {
            this.notifica = {
              show: true,
              color: 'warning',
              icon: 'priority_high',
              mensagem: responseError.data.message
            }
          } else {
            this.notifica = {
              show: true,
              color: 'error',
              icon: 'warning',
              mensagem: 'Erro ao recuperar usuário. Token inválido.'
            }
          }
          const _this = this
          setTimeout(function () {
            _this.$router.push({ name: 'auth.login' })
          }, 10000)
        })
    },
    redefinirSenha () {
      this.error.error = false
      this.error.messages = []
      if (this.formResetPassword.password === this.formResetPassword.password_confirmation) {
        ResetPassword.resetPassword(this.formResetPassword)
          .then(response => {
            this.formResetPassword.password = ''
            this.formResetPassword.password_confirmation = ''
            this.formResetPasswordActive = false
            this.notifica = {
              show: true,
              color: 'success',
              icon: 'check_circle',
              mensagem: response.data.message
            }
          })
          .catch(responseError => {
            this.error.error = true
            if (responseError.status === 412) {
              this.notifica = {
                show: true,
                color: 'error',
                icon: 'warning',
                mensagem: responseError.data.message
              }
            } else {
              this.notifica = {
                show: true,
                color: 'error',
                icon: 'warning',
                mensagem: 'Erro ao redefinir senha. Atualize a página e tente novamente.'
              }
              const _this = this
              setTimeout(function () {
                _this.$router.push({ name: 'auth.login' })
              }, 2000)
            }
          })
      } else {
        this.error.error = true
        this.error.messages.push('As senhas não são idênticas.')
      }
    }
  },
  computed: {
    ...mapGetters({
      info: ['App/info']
    }),
    userNotEmpty () {
      return Object.keys(this.user).length !== 0
    }
  }
}
</script>

<style scoped>
div.application {
  background: #ffffff url("/static/img/bg_login.jpg") no-repeat fixed center;
}
</style>
